export default {
  setPollingId(state, pollingId) {
    state.pollingId = pollingId
  },

  unsetPollingId(state) {
    state.pollingId = null
  },
}
